import type { GameState, Point } from '../shared/types';

/** GameLiving.needFocus sends the map (x, y−150), before map-bound clamping. */
export function sourcePlayerFocus(player: Point): Point {
  return { x: player.x, y: player.y - 150 };
}

/** ChangePlayerAction waits for the old walk/fall and shoot actions to finish. */
export function cameraTurnPlayerId(state: GameState, presentedPlayerId: string, serverNow: number): string {
  return serverNow >= state.turn.readyAt ? state.turn.playerId : presentedPlayerId;
}
